var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboardImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 60,
    viewBox: "0 0 63 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62.677,
    height: 59.7025,
    rx: 8,
    fill: "#19FB80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5623 38.0876L40.4998 38.5751C40.0373 38.6876 39.6748 39.0376 39.5748 39.5001L39.1373 41.3376C38.8998 42.3376 37.6248 42.6501 36.9623 41.8626L33.2248 37.5626C32.9248 37.2126 33.0873 36.6626 33.5373 36.5501C35.7498 36.0126 37.7373 34.7751 39.1998 33.0126C39.4373 32.7251 39.8623 32.6876 40.1248 32.9501L42.8998 35.7251C43.8498 36.6751 43.5123 37.8626 42.5623 38.0876Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 38.0876L21.4375 38.5751C21.9 38.6876 22.2625 39.0376 22.3625 39.5001L22.8 41.3376C23.0375 42.3376 24.3125 42.6501 24.975 41.8626L28.7125 37.5626C29.0125 37.2126 28.85 36.6626 28.4 36.5501C26.1875 36.0126 24.2 34.7751 22.7375 33.0126C22.5 32.7251 22.075 32.6876 21.8125 32.9501L19.0375 35.7251C18.0875 36.6751 18.425 37.8626 19.375 38.0876Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 17.5C26.1625 17.5 22.25 21.4125 22.25 26.25C22.25 28.0625 22.7875 29.725 23.7125 31.1125C25.0625 33.1125 27.2 34.525 29.6875 34.8875C30.1125 34.9625 30.55 35 31 35C31.45 35 31.8875 34.9625 32.3125 34.8875C34.8 34.525 36.9375 33.1125 38.2875 31.1125C39.2125 29.725 39.75 28.0625 39.75 26.25C39.75 21.4125 35.8375 17.5 31 17.5ZM34.825 25.975L33.7875 27.0125C33.6125 27.1875 33.5125 27.525 33.575 27.775L33.875 29.0625C34.1125 30.075 33.575 30.475 32.675 29.9375L31.425 29.2C31.2 29.0625 30.825 29.0625 30.6 29.2L29.35 29.9375C28.45 30.4625 27.9125 30.075 28.15 29.0625L28.45 27.775C28.5 27.5375 28.4125 27.1875 28.2375 27.0125L27.175 25.975C26.5625 25.3625 26.7625 24.75 27.6125 24.6125L28.95 24.3875C29.175 24.35 29.4375 24.15 29.5375 23.95L30.275 22.475C30.675 21.675 31.325 21.675 31.725 22.475L32.4625 23.95C32.5625 24.15 32.825 24.35 33.0625 24.3875L34.4 24.6125C35.2375 24.75 35.4375 25.3625 34.825 25.975Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardImg1);
export default __webpack_public_path__ + "static/media/leaderboard_img1.7b0ac256a9c7ed09685ee9273774ba4b.svg";
export { ForwardRef as ReactComponent };